import { industry_endpoint } from "@/config/endpoints";
import axiosInstance from "@/lib/axios";
import { useAppSelector } from "@/stores/hook";
import { useQuery } from "@tanstack/react-query";

export default function useCurrentIndustry() {
  const {
    currentUser: { user },
  } = useAppSelector((state) => state.auth);

  const industryId = user.tenant.industryId;

  const query = useQuery({
    queryKey: ["get-industry", industryId],
    queryFn: async () => {
      const res = await axiosInstance.get(`${industry_endpoint}/${industryId}`);
      return res.data.industry;
    },
  });

  return {
    industry: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
